import React, { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useAppSelector } from "../Store"
import { useUser } from "../Services"
import { setStates } from "../Store/StateHandlers/active-slice"
import { Pages, NavigationFunction as RootNavigation } from "../Navigation/Routers/root"
import { StyleObject } from "styletron-react"
import { logos, frames, glyphs } from "../Styles"
import { Button, NewSelect } from "../Components"
import { ButtonTypes, SelectFieldOption_Values, NewFieldStyles } from "../Definitions"

interface LogoDisplay_Props {
    ChooseSite?: boolean
    goBackBtn?: string,
    overrides?:{
        gridArea?: string
    }
    selectedPage?: string
  }

export default function LogoDisplay({goBackBtn, overrides, ChooseSite, selectedPage}:LogoDisplay_Props) {
  const {t} = useTranslation()
  const dispatch = useDispatch()
  const { userFarms, getUserFarms, doLogOut } = useUser()
  const activefarm = useAppSelector<string|undefined>(({activeData}) => activeData?.farm)
  const navigator = useNavigate()
 
  useEffect(() => {
    getUserFarms()
  },[getUserFarms])

  const _Root = useMemo<StyleObject>(() => {
    return Object.assign(
      {} as StyleObject,
      overrides&&overrides.gridArea? {gridArea:overrides.gridArea} : {}
    )
  },[overrides])

  const Data = useMemo<{label:string, domain:string}[]>(() => {
    if (!userFarms) return []
    
    const farms = userFarms.map(farm => ({
      label: farm.name,
      domain: farm.domain,
      icon: <></>
    }));
    
    farms.push({
      label: t("loginFlow.def.goToSiteList", {defaultValue: "Go to Site List"}),
      domain: 'navigate-to-list',
      icon: <glyphs.Animal/>
    });

    if (selectedPage !== "op_operations") {
      farms.push({
        label: t("loginFlow.def.switchToOperations", {defaultValue: "Switch to Operations View"}),
        domain: "navigate-to-operations",
        icon: <glyphs.Animal/>
      });
    } else {
      farms.push({
        label: t("loginFlow.def.switchToCloud", {defaultValue: "Switch to Cloud View"}),
        domain: "navigate-to-cloud",
        icon: <glyphs.Animal/>
      });
    }

    farms.push({
      label: t("loginFlow.login.logOut", {defaultValue: "Log Out"}),
      domain: 'logout',
      icon: <glyphs.Animal/>
    });

    return farms
  }, [selectedPage, t, userFarms])

  const handleChange = (selectedOption: SelectFieldOption_Values | null) => {
    if (selectedOption === null) {
      return;
    }
  
    if (selectedOption.domain === 'navigate-to-list') {
      RootNavigation(navigator, Pages.login, undefined, true, {selected: selectedPage });
    } else if (selectedOption.domain === 'navigate-to-operations') {
      RootNavigation(navigator, Pages.op_operations, undefined, true, {selected: selectedPage })
    } else if (selectedOption.domain === 'navigate-to-cloud') {
      RootNavigation(navigator, Pages.kpi, undefined, true, {selected: selectedPage })
    } else if (selectedOption.domain === 'logout') {
      RootNavigation(navigator, Pages.def); doLogOut();
    } else {
      dispatch(setStates({ type: 'farm', farm: selectedOption.domain }));
    }
  };

  return(
    <frames.LogoDisplay $style={_Root}>
      <img src={logos.whiteFreedaLogo} style={{width: "280px", marginBottom: "12px"}} alt="Company logo"/>
      {/* Go Back Button on Logo Display */}
      {!goBackBtn?(<></>):(
        <Button
          content={goBackBtn}
          startEnhancer={glyphs.Arrow({rotate:180})}
          buttonType={ButtonTypes.textButton}
          onClick={() => {RootNavigation(navigator, Pages.login)} }
        />
      )}
      {/* SelectField to choose site but also go to site list in loginflow */}
      {!ChooseSite?(<></>):
        <NewSelect
          placeholder="Vælg..."
          options={Data}
          onChange = {(e) => handleChange(e ?? null)}
          fieldOverrides={{
            fieldStyle: NewFieldStyles.greyDarkSecondary
          }}
          valueOverrides={{
            defaultValue: Data.find(e => e.domain === activefarm)
          }}
        />
      }
    </frames.LogoDisplay>  
  )
}